module.exports = __webpack_public_path__ + "img/icon_1_33.178127ae.png";